<template>
  <div class="right-btns">
    <span class="hash-tag">
      <slot name="hash-tag"></slot>
    </span>
    <span v-if="slots['hash-tag']" class="divider">&ensp;|&ensp;&ensp;</span>
    <span class="emoji-icon"> <slot name="emoji-icon"></slot></span>
  </div>
</template>

<script setup>
import { useSlots } from 'vue'
const slots = useSlots()
</script>

<style lang="scss" scoped>
.right-btns {
  display: flex;
  align-items: center;
  line-height: 28px;

  .divider {
    color: #bdbdbd;
  }

  .hash-tag {
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
